import { dynamicImage } from "../../../Service/DynamicImage";

//Default lists
export const DEFAULT_DATA = [
  {
    text: "Use the ",
    code: ".list-group ",
  },
  {
    text: "define the list of items. and used ",
    code: ".list-group-item ",
  },
  {
    text: "to indicate the current content.",
  },
];

export const DEFAULT_LIST = ["Web Design & Development", "E-Commerce", "SEO"];

//Active List
export const ACTIVE_DATA = [
  {
    text: "Use ",
    code: ".active ",
  },
  {
    text: "to a",
    code: ".list-group-item",
  },
  {
    text: " to indicate the current active.",
  },
];

export const ACTIVE_LIST = ["Wow Animations", "Apex Charts", "Starter Kits"];

//Flush list
export const FLUSH_DATA = [
  {
    text: "Use ",
    code: " .list-group-flush",
  },
  {
    text: " to remove some borders and rounded corners to render list group items.",
  },
];

export const FLUSH_LIST = ["PRODUCT DETAILS", "CART", "CHECKOUT"];

//Contextual Classe
export const CONTEXTUAL_DATA = [
  {
    text: "Use contextual classes to style list items with a stateful background and color.",
    code: ".list-light-*",
  },
  {
    text: " and ",
    code: "txt-*",
  },
];

export const CONTEXTUAL_LIST = ["secondary", "success", "danger", "warning", "info", "white", "dark"];

//Horizontal List
export const HORIZONTAL_DATA = [
  {
    text: "Use ",
    code: ".list-group-horizontal",
  },
  {
    text: "to change the layout of list group items from vertical to horizontal across all breakpoints.",
    code: ".list-group-horizontal-[sm/md/lg/xl/xxl].",
  },
];

export const HORIZONTAL_LIST = [
  {
    color: "secondary",
    item: ["Basic table", "Sizing table ", "Border table", "Basic inputs ", "Form validations"],
  },

  {
    color: "warning",
    item: ["Flat style ", "Edge style ", "Button group", "Rating", "Crypto"],
  },
  {
    color: "success",
    item: ["Blog ", "Blog details ", "Blog single ", "Order history "],
  },
  {
    color: "info",
    item: ["Gallery grid  ", "Gallery desc", "Masonry Desc"],
  },
];

export const HORIZONTAL_LIST_DATA = ["Product details", "Pricing", "Payment details", "Checkout ", "Mega options "];

//Custom Content List
export const CUSTOM_DATA = [
  {
    text: "Use the ",
    code: ".list-group-item",
  },
  {
    text: " through make custom design of all lists.",
  },
];

export const CUSTOM_LIST = [
  {
    src: dynamicImage("user/3.png"),
    title: "Gabrielle Fahey",
    mail: "GabrielleFahey@dayrep.com",
    days: "10 days ago",
    text: "Your aim with this blog is to advertise yourself and your services in blog design. That means it's vital to create content about just that: blog design. Anything else on your page may act as a distraction to your potential customers, and you don't want that!",
    smallText: "100 Followers",
  },

  {
    src: dynamicImage("user/2.jpg"),
    title: "Lucinda Moseley",
    mail: "LucindaMoseley@teleworm.us",
    days: "3 days ago",
    text: "People who are looking to hire a web designer may not know what to look out for. This will give you a chance to prove your trustworthiness by providing potential customers with advice and will let you sell your services by highlighting their best qualities.",
    smallText: "23M Followers ",
  },
];

//ListsWith Check boxs
export const LIST_CHECKBOX_DATA = [
  {
    text: "Use the ",
    code: ".form-check-input ",
  },
  {
    text: "to check your checkbox.",
  },
];

export const LIST_CHECKBOX_LIST = [
  {
    color: "secondary",
    text: "Auto Update",
  },
  {
    color: "success",
    text: " Don't check auth key",
  },
  {
    color: "warning",
    text: "Success all",
  },
];

//Lists With Radios
export const LIST_RADIO_DATA = [
  {
    text: "Use the ",
    code: ".form-check-input ",
  },
  {
    text: "to check your radio buttons.",
  },
];

export const LIST_RADIO_LIST = [
  {
    color: "primary",
    text: "Read a book",
  },
  {
    color: "success",
    text: "Learn to code ",
  },
  {
    color: "info",
    text: "Drink more water",
  },
];

//Lists With Number
export const LIST_NUMBER_DATA = [
  {
    text: "Use the ",
    code: ".list-group-numbered",
  },
  {
    text: "to ordered wise print numbers.",
  },
];

export const LIST_NUMBER_LIST = [
  {
    color: "danger",
    text: "Solve your problem with us",
  },
  {
    color: "success",
    text: "Certified Professionals",
  },
  {
    color: "warning",
    text: "Growth-Driven ",
  },
];

//JavaScript Behavior
export const JAVASCRIPT_DATA = [
  {
    text: " Use the tab JavaScript plugin—include it individually or through the compiled",
    code: " bootstrap.js ",
  },
  {
    text: "file to extend our list group to create table panes of local content.",
  },
];

//Numbered Badge List
export const NUMBERED_BUDGE_DATA = [
  {
    text: "  Use the",
    code: " .list-group-numbered",
  },
  {
    text: " modifier class to  numbered list group items.Numbers are generated via CSS for better placement inside list group items.",
  },
];

export const NUMBERED_BUDGE_LIST = [
  {
    title: "Lola Stanford",
    color: "danger",
    text: "Issue",
  },
  {
    title: "Caitlin Coungeau",
    color: "primary",
    text: "Social",
  },
  {
    title: "Graciela W. McClaran",
    color: "danger",
    text: "Issue",
  },
];

//Disabled List
export const DISABLE_LIST_DATA = [
  {
    text: "  Use",
    code: " .disabled ",
  },
  {
    text: "to a ",
    code: ".list-group-item",
  },
  {
    text: " to make it appear disabled.",
  },
];

export const DISABLE_LIST = [
  {
    className: "bg-light-hover-primarye",
    text: "Gloria D. Acheson",
    src: dynamicImage("user/5.jpg"),
  },
  {
    className: "disabled",
    text: "Sharon C. Obrien",
    src: dynamicImage("user/5.jpg"),
  },
  {
    className: "disabled",
    text: "Bryan A. Owens",
    src: dynamicImage("user/5.jpg"),
  },
];

//Scrollable List
export const SCROLLABLE_DATA = [
  {
    text: "Use the property ",
    code: "overflow:auto ",
  },
  {
    text: "through scrollable lists.",
  },
];

export const SCROLLABLE_LIST = [
  {
    src: dynamicImage("user/10.jpg"),
    title: "Gabrielle Fahey",
    mail: "GabrielleFahey@dayrep.com",
    days: "10 days ago",
  },
  {
    src: dynamicImage("user/2.jpg"),
    title: "Lucinda Moseley",
    mail: "LucindaMoseley@teleworm.us",
    days: "3 days ago",
  },
  {
    src: dynamicImage("user/12.png"),
    title: "Francis K. Henriques",
    mail: "FrancisKHenriques@teleworm.us",
    days: "2 days ago",
  },
  {
    src: dynamicImage("user/14.png"),
    title: "Jose A. Seay",
    mail: "JoseASeay@rhyta.com",
    days: "15 days ago",
  },
  {
    src: dynamicImage("user/3.jpg"),
    title: "Phil F. Cunningham",
    mail: "PhilFCunningham@dayrep.com",
    days: "6 days ago",
  },
  {
    src: dynamicImage("user/7.jpg"),
    title: "Richard E. Johnson",
    mail: "RichardEJohnson@teleworm.us",
    days: "20 days ago",
  },
  {
    src: dynamicImage("user/2.png"),
    title: "Lawrence L. Nash",
    mail: "LawrenceLNash@jourrapide.com",
    days: "8 days ago",
  },
];
